/*
 * Golden serial capture, revision 2 (2026-10-21). Works with snippets/msp-serial-capture.liquid (same date).
 * Not on any theme yet: the next test copy of the live theme gets these files.
 *
 * What changed from the 2026-09-28 version:
 * - Validation now matches the order bot exactly, including the 2026-09-29 rule: five or more opening letters is a
 *   word, not a serial ("unknown2019" is refused).
 * - Live feedback: a quiet green line appears as soon as the typed value has the right shape, so the shopper knows
 *   before pressing Add to Cart.
 * - Buy it now / Shop Pay buttons skip the Add to Cart check, so they stay hidden on a serial part until the shopper
 *   has typed a good serial or ticked the box (class msp-serial-pending on the form).
 * - The serial is tidied (capitals, no spaces or dashes) as the shopper leaves the field, not only at submit.
 *
 * Loaded on every page (layout/theme.liquid) with delegated listeners, so the quick add drawer gets the same checks.
 */
(function () {
  if (window.mspSerialCaptureReady) return;
  window.mspSerialCaptureReady = true;

  var ROOT = '[data-msp-serial]';
  var PENDING = 'msp-serial-pending';
  var MSG_EMPTY = 'Add the serial number from the sticker, or tick the box below and we will email you for it.';
  var MSG_SHAPE = 'That does not look like a Golden serial number. They are 9 to 12 letters and numbers starting with letters, like QCB21K0417. Check the sticker marked S/N, or tick the box below.';
  var MSG_OK = 'Looks right. It goes on your order as ';

  function normalize(value) {
    return String(value || '').toUpperCase().replace(/[\s-]+/g, '');
  }

  // Golden serial shape, measured 2026-10-21 on the 22 Golden serials the order bot has on file: 9 to 12 characters,
  // 2 to 4 opening letters then a digit, at least 5 digits in all (QCB21K0417-shaped). Tighter than the bot's own
  // 6-to-15 gate on purpose: anything that passes here passes the bot too.
  function isValidSerial(value) {
    if (!/^[A-Z0-9]{9,12}$/.test(value)) return false;
    if (!/^[A-Z]{2,4}[0-9]/.test(value)) return false;
    var digits = (value.match(/[0-9]/g) || []).length;
    if (digits < 5) return false;
    if (/^SO[0-9]+$/.test(value)) return false;
    return true;
  }

  function parts(root) {
    return {
      input: root.querySelector('[data-msp-serial-input]'),
      later: root.querySelector('[data-msp-serial-later]'),
      laterValue: root.querySelector('[data-msp-serial-later-value]'),
      entry: root.querySelector('[data-msp-serial-entry]'),
      error: root.querySelector('[data-msp-serial-error]'),
      ok: root.querySelector('[data-msp-serial-ok]')
    };
  }

  function complete(p) {
    return p.input && p.later && p.laterValue && p.entry && p.error;
  }

  function showError(p, message) {
    p.error.textContent = message || '';
    p.error.hidden = !message;
    if (message) {
      p.input.setAttribute('aria-invalid', 'true');
    } else {
      p.input.removeAttribute('aria-invalid');
    }
  }

  function showOk(p, value) {
    if (!p.ok) return;
    if (value) {
      p.ok.textContent = MSG_OK + value + '.';
      p.ok.hidden = false;
    } else {
      p.ok.textContent = '';
      p.ok.hidden = true;
    }
  }

  function settled(root, p) {
    // True when the shopper has done what the part needs: a good serial or the box.
    if (root.hidden) return true;
    if (p.later.checked) return true;
    return isValidSerial(normalize(p.input.value));
  }

  function sync(root) {
    var p = parts(root);
    if (!complete(p)) return;
    var active = !root.hidden;
    var sendLater = p.later.checked;
    p.input.disabled = !active || sendLater;
    p.laterValue.disabled = !active || !sendLater;
    p.entry.hidden = sendLater;
    if (sendLater || !active) {
      showError(p, '');
      showOk(p, '');
    } else {
      var value = normalize(p.input.value);
      showOk(p, isValidSerial(value) ? value : '');
    }
    var form = root.closest('form');
    if (form) {
      if (settled(root, p)) {
        form.classList.remove(PENDING);
      } else {
        form.classList.add(PENDING);
      }
    }
  }

  function closestRoot(target) {
    return target && target.closest ? target.closest(ROOT) : null;
  }

  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('[data-msp-serial-later]')) return;
    var root = closestRoot(t);
    if (root) sync(root);
  });

  document.addEventListener('input', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('[data-msp-serial-input]')) return;
    var root = closestRoot(t);
    if (!root) return;
    var p = parts(root);
    if (!complete(p)) return;
    if (!p.error.hidden) showError(p, '');
    sync(root);
  });

  document.addEventListener('focusout', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('[data-msp-serial-input]')) return;
    var value = normalize(t.value);
    if (value && t.value !== value) t.value = value;
    var root = closestRoot(t);
    if (root) sync(root);
  });

  document.addEventListener('on:variant:change', function (evt) {
    var detail = evt.detail || {};
    var variant = detail.variant;
    if (!variant) return;
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      if (detail.product && String(detail.product.id) !== root.dataset.productId) continue;
      if (detail.form && detail.form.contains && !detail.form.contains(root)) continue;
      var ids = (root.dataset.variantIds || '').split(',').filter(Boolean);
      root.hidden = ids.indexOf(String(variant.id)) === -1;
      sync(root);
    }
  });

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.querySelector) return;
    var root = form.querySelector(ROOT);
    if (!root || root.hidden) return;
    var p = parts(root);
    if (!complete(p)) return;
    sync(root);
    if (p.later.checked) return;
    var value = normalize(p.input.value);
    var message = '';
    if (!value) {
      message = MSG_EMPTY;
    } else if (!isValidSerial(value)) {
      message = MSG_SHAPE;
    }
    if (message) {
      evt.preventDefault();
      evt.stopPropagation();
      showError(p, message);
      p.input.focus();
      return;
    }
    p.input.value = value;
  }, true);

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i += 1) sync(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
